import React, { createContext, useContext, ReactNode } from 'react';

interface NavigationContextType {
    /** Navigate to a different path. If navigation is happening to the external source, please set 'isExternal' to true */
    navigate?: (path: string, isExternal: boolean) => void;
    /** Current path in the navigation context */
    currentPath?: string | undefined;
    /** Check if a route is active, if 'exact' flag is set then we should check for exact match, and not just part of the route */
    isActiveRoute?: (url: string, exact: boolean) => boolean;
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

export interface NavigationProviderProps {
    children: ReactNode;
}

export const NavigationProvider: React.FC<NavigationProviderProps & Partial<NavigationContextType>> = ({ 
    children, 
    navigate,
    isActiveRoute,
    currentPath
}) => {
    const value = React.useMemo(() => ({
        navigate,
        currentPath,
        isActiveRoute
    }), [navigate, currentPath, isActiveRoute]);

    return (
        <NavigationContext.Provider value={value}>
            {children}
        </NavigationContext.Provider>
    );
};

export const useNavigation = (): NavigationContextType => {
    const context = useContext(NavigationContext);
    if (!context) {
        throw new Error('useNavigation must be used within a NavigationProvider');
    }
    return context;
};